import axios from "axios";
import { getAPIUrl } from "../config";
import { headerConfig } from "./authConfig";
const serviceEndPoint = `${getAPIUrl()}/api/support`;
const servicePerformanceEndPoint = `${getAPIUrl()}/api/performance`;

export const getSupportData = async () => {
  const result = await axios.get(serviceEndPoint, headerConfig());
  return result.data;
};
export const getPerformanceData = async () => {
  const result = await axios.get(servicePerformanceEndPoint, headerConfig());
  // if (result?.data?.success == false) {
  //   clearLocalStorage();
  // };
  return result.data;
};
export const getLastMonthPerformance = async () => {
  const result = await axios.get(`${servicePerformanceEndPoint}/last-month`, headerConfig());
  return result.data;
};
export const addSupportData = async (data) => {
  const result = await axios.post(serviceEndPoint, data, headerConfig());
  return result.data;
};
export const getUserById = async (id) => {
  const result = await axios.get(
    `${serviceEndPoint}/${id}`,
    headerConfig()
  );
  return result.data;
};
export const updateSupportData = async (data) => {
  const result = await axios.put(
    serviceEndPoint,
    {
      id: data._id,
      name: data.name,
      password: data.password,
      email: data.email,
      phone: data.phone,
      active: data.active,
      role: data.role,
    },
    headerConfig()
  );
  return result.data;
};
// export const deleteUser = async (id) => {
//   let data = JSON.stringify({
//     "id": id
//   });
//   console.log("headerConfig()::::>", headerConfig());
//   const result = await axios.delete(serviceEndPoint, data,
//     headerConfig(),
//   );
//   return result.data;
// };

export const deleteUser = async (id) => {
  try {
    const result = await axios.delete(serviceEndPoint, {
      data: {
        id: id
      },
      ...headerConfig()
    });
    return result.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};